/**
 * @file Contains helper functions for SearchList component
 */
import userGetName from '../../../../../utils/user/userGetName';
import { SearchDataItem } from '../types';

/**
 * Get the color for the checkbox badge
 *
 * @param item Item data (member, userGroup or label)
 * @returns    Color for the checkbox badge
 */
export const getBadgeColor = (item: SearchDataItem) => {
  if ('color' in item) {
    return item.color;
  }
  return undefined;
};

/**
 * Get the label for the checkbox
 *
 * @param item Item data (member, userGroup or label)
 * @returns    Label for the checkbox
 */
export const getLabel = (item: SearchDataItem) => {
  if ('title' in item) {
    return item.title;
  }
  if ('text' in item) {
    return item.text;
  }
  return userGetName(item);
};

/**
 * Get the data for the checkbox avatar
 *
 * @param item Item data (member, userGroup or label)
 * @returns    User data or undefined
 */
export const getUserData = (item: SearchDataItem) => {
  if ('title' in item || 'text' in item) {
    return undefined;
  }
  return item;
};
